import React from 'react'
import { connect } from 'react-redux'
import { TradingEntityClearingDetail } from 'api'
import { ActionItem, SplitButtonDropdown } from 'view/components/menus'
import { ActionsButtonProps } from 'view/components/datagrid'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { Locale, Translation } from 'locale'
import { ViewTradingEntityDirectClearingDialog } from './ViewTradingEntityClearingDialog'

export interface ViewClearingPanelActionsButtonProps extends ModalConsumerProps, ActionsButtonProps<TradingEntityClearingDetail> {}

export const ViewTradingEntityClearingPanelActionsButtonComponent: React.FunctionComponent<ViewClearingPanelActionsButtonProps> = props => {
  const { items, showModal } = props

  const handleShowItemDialog = (tradingEntityClearingDetail: TradingEntityClearingDetail[]) => {
    const { id, type } = tradingEntityClearingDetail[0].tradingEntityClearing

    showModal(<ViewTradingEntityDirectClearingDialog tradingEntityClearingType={type} entityId={id} />)
  }

  const actions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_ACTION_VIEW_DETAILS),
      onClick: () => handleShowItemDialog(items)
    }
  ]

  return <SplitButtonDropdown actions={actions} maxButtons={1} />
}

export const ViewTradingEntityClearingPanelActionsButton = withModal(connect()(ViewTradingEntityClearingPanelActionsButtonComponent))
